import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../ampli';
import { MainHead } from '../../../components/common/head/MainHead';
import { AnimateLoading } from '../../../components/common/loading/AnimateLoading';
import { pageInfo } from '../../../constants/pageInfo/pageInfo.constant';
import { usePatchInformationByIdMutation } from '../../../hooks/api/information/mutations/usePutInformationById.mutation';
import { useGetInformationByIdQuery } from '../../../hooks/api/information/queries/useGetInformationById.query';
import { useGetInformationNeighborsByIdQuery } from '../../../hooks/api/information/queries/useGetInformationNeighborsById.query';
import { useLayout } from '../../../hooks/screen/useLayout';
import { getEventPages } from '../../../utils/getter/getEventPages';
import { InfoDetailView } from '../../../views/Info/detailView/InfoDetailView/InfoDetailView';
import { InfoDetailPageFooter } from './components/InfoDetailPageFooter';
import { Button } from '../../../components/common/buttons/Button';

export const InfoDetailPage = () => {
  const navigate = useNavigate();
  const { informationId } = useParams();
  const [isAmpliEventCalled, setIsAmpliEventCalled] = useState<boolean>(false);

  const { data: information, isLoading: isGetInformationQueryLoading } = useGetInformationByIdQuery({
    informationId: informationId!,
  });

  const { data: informationNeighbors, isLoading: isGetInformationNeighborsQueryLoading } =
    useGetInformationNeighborsByIdQuery({
      informationId: informationId!,
    });

  const { mutate: putInformationById } = usePatchInformationByIdMutation();

  useLayout({
    fixedHeader: <MainHead backButton={{ isShow: true, directlyPassedURL: pageInfo.infoListPage.path }} />,
    fixedFooter: information?.footerButtonVisible ? (
      <InfoDetailPageFooter>
        <Button
          borderType={'square'}
          color={'filledPrimaryStrong'}
          size={'md'}
          text={{ size: 'md', content: information.footerButtonText ?? '' }}
          onClick={() => {
            window.location.href = information.footerButtonLandingUrl ?? '';
            ampli.pvmClickIdpFab({
              title: information.title ?? '',
            });
          }}
        />
      </InfoDetailPageFooter>
    ) : (
      <></>
    ),
    fixedHeaderHeight: 48,
    style: {
      background: '#F0f0f0',
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (information && informationId && !isAmpliEventCalled) {
      putInformationById({ informationId, reqBody: { views: information.views + 1 } });

      ampli.정보상세페이지조회({
        '게시글 제목': information.title ? information.title : '',
      });

      setIsAmpliEventCalled(true);
    }
  }, [information, isAmpliEventCalled]);

  // 값진년 이벤트 관련 코드

  useEffect(() => {
    if (informationId) {
      const eventPages = getEventPages();

      const targetEventPage = eventPages.find((value) => {
        return value.id === informationId;
      });

      if (targetEventPage) {
        navigate(targetEventPage.path, { replace: true });
      }
    }
  }, [informationId]);

  if (isGetInformationQueryLoading || isGetInformationNeighborsQueryLoading) return <AnimateLoading />;

  if (information && informationNeighbors) {
    return (
      <>
        <Helmet>
          <title>{`${information.title && `${information.title} -`} Pluva Market`}</title>
        </Helmet>
        <InformationDetailViewWrap>
          <InfoDetailView information={information} informationNeighbors={informationNeighbors} />
        </InformationDetailViewWrap>
      </>
    );
  }

  return <></>;
};

const InformationDetailViewWrap = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;
